import React, {  useEffect, useState,useRef,useContext  } from "react";
import ReactGA from 'react-ga4';
import { useNavigate,Link,useParams  } from 'react-router-dom';
import Lang from '../../../lang/translations';
import Context from '../../../context/context';
import queryString from 'query-string';
import helpersFunction from "../../../_helpers/helpersFunction";

import shift4_functions from "./functions";
const config = require("../../../_helpers/configServizi"); 




export default function Ok() {
    
    const query = queryString.parse(window.location.search);
    
    var redirectResult = query.redirectResult
    const [spinner, setSpinner] = useState(true);
    const context = useContext(Context)
    const navigate = useNavigate() 

     function Spinner(){
     
             if(spinner){
               return (<div className="waiterAdattivo">
                   <div className="spinner-adattivo" role="status">
               <span className="sr-only"></span>
               
             </div>
             <div className="testoSpinner">
                   <Lang w={"processando_pagamento"} page={"payment_page"}/>
             </div>
           
             </div>);
             }return false
           }
    
    useEffect(() => {

        const domain = window.location.hostname
        
        if(query.liabilityShift === "failed"){
            const contenuto = helpersFunction.contenuto_popop_pagamento("payment_canceled")
            helpersFunction.showPopupgenerico("blocked",context,contenuto)
            return
        }

        shift4_functions.finalizePayment({clickid:localStorage.getItem('trackerId'),domain :domain,payment_company : config.servizi[domain].payment_company})
            .then(response=>{
             
                console.log("risposta su errore", response)
                
                
                    const contenuto = helpersFunction.contenuto_popop_pagamento(response.message)
                    helpersFunction.showPopupgenerico("blocked",context,contenuto)
                    
                if (response.status === "ko") { 
                    console.log("Errore pagamento mi fermo qui", response )
                    return
                }

                console.log("Pagamento andato a buon fine, procedo con il flusso", response )

                setTimeout(function(){ 
                    context.Socket.emit('chat', context.messaggioPending);
                    context.setMessaggioPending(null);
                    window.location.replace("/chats")  
                }, 3000);

            }).catch(err=>{
                console.log("Errore SHIFT4: ", err)
                const contenuto = helpersFunction.contenuto_popop_pagamento("generico")
                helpersFunction.showPopupgenerico("blocked",context,contenuto)
                
            })
           
      
       
     },[])
    

    return (<div className="all-container bg-light pianiAbbonamentoPage">
               <Spinner />
            </div>
    )
   


}